var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listmain "},[_c('h1',{staticClass:"firTitle"},[_vm._v("智能家居技能")]),_vm._v(" "),_c('p',[_vm._v("猎户语音OS为智能家居开发者提供了更加标准的开发接口，开发者仅需少量配置和开发工作即可迅速完成语音交互技能。用户可以通过声音来控制智能设备，查看设备的状态，如控制开灯、关灯。")]),_vm._v(" "),_c('p',[_vm._v("稍安毋躁，即将面世。。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2530031e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutor/znjjjn.vue
// module id = null
// module chunks = 